import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './imageLightbox.module.scss';

export default function ImageLightbox({ image, onClose, closeButtonRef }) {
  useEffect(() => {
    if (!image) return undefined;

    requestAnimationFrame(() => {
      closeButtonRef.current?.focus();
    });

    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [image, onClose, closeButtonRef]);

  if (!image) return null;

  return createPortal(
    <div className={styles.root} role="dialog" aria-modal="true" aria-label="Enlarged image">
      <button
        type="button"
        className={styles.backdrop}
        onClick={onClose}
        aria-label="Close enlarged image"
        tabIndex={-1}
      />
      <div className={styles.content}>
        <button
          ref={closeButtonRef}
          type="button"
          className={styles.close}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <img src={image.src} alt={image.alt} className={styles.img} />
      </div>
    </div>,
    document.body
  );
}
